import styled from "styled-components"
import media from "../../global/media"

const PopUpWrapper = styled.div`
  position: absolute;
  top: ${(props) => (props.topPosition ? `${props.topPosition}px` : "60px")};
  left: ${(props) => props.position}px;
  ${media.tablet`
    ${(props) => props.hideOnMobile && "display: none;"}
    left: ${(props) => props.position - 60}px;
  `}
  .tooltipPopup-appear {
    opacity: 0.5;
    transform: translate(0, -2.5em) scale(0.8);
  }
  .tooltipPopup-appear.tooltipPopup-appear-active {
    opacity: 1;
    transform: translate(0, 0.7em) scale(1.1);
    transition: 0.8s ease-in-out;
  }
  .tooltipPopup-enter {
    opacity: 0.5;
    transform: translate(0, -2.5em) scale(0.8);
  }
  .tooltipPopup-enter.tooltipPopup-enter-active {
    opacity: 1;
    transform: translate(0, 0.7em) scale(1.1);
    transition: 0.8s ease-in-out;
  }
  .tooltipPopup-exit {
    opacity: 1;
  }
  .tooltipPopup-exit.tooltipPopup-exit-active {
    opacity: 0.01;
    transition: opacity 300ms ease-in;
  }
`
export default PopUpWrapper
